import UltMeta, { Meta } from "./UltMeta/index";

// 船运单类型
class ShipWayBillTypePC extends UltMeta {
    SUPERVISION = new Meta(1, "服务运单");
    MATCHING = new Meta(2, "撮合运单");
}
export const SHIP_WAY_BILL_TYPE_PC = new ShipWayBillTypePC();


// 服务商类型
class ServiceProviderTypePC extends UltMeta {
    SERVICE= new Meta(1, "服务商垫付");
    SELF = new Meta(2, "自行支付");
}
export const SERVICE_PROVIDER_TYPE_PC = new ServiceProviderTypePC();


// 取消原因
class OwnerCancelReasonType extends UltMeta {
    BOAT_DEMAND_CANCELLED = new Meta(10, "用船需求取消");
    SERVICE_EXPERIENCE_UNSATISFACTORY = new Meta(13, "服务体验不佳");
    INFORMATION_ERROR = new Meta(7, "填写信息有误");
    FEES_INAPPROPRIATE = new Meta(11, "费用不合适(定金、信息服务费)");
    ALTERNATIVE_CHANNEL_FOUND = new Meta(12, "已通过其他渠道找到船");
    WAIT_TIME_TOO_LONG = new Meta(9, "等待时间太长");
}

export const OWNER_CANCEL_REASON_TYPE = new OwnerCancelReasonType();